import { render } from "./DataImportWizard.vue?vue&type=template&id=60fabca8"
import script from "./DataImportWizard.vue?vue&type=script&lang=ts"
export * from "./DataImportWizard.vue?vue&type=script&lang=ts"

import "./DataImportWizard.vue?vue&type=style&index=0&id=60fabca8&lang=scss"
script.render = render

export default script